export const Api_Url = `https://api.arccjournals.com`
